// "Depois do login, volte para onde você ia" — o `?volta=` do /login.
//
// Existe por causa dos AVISOS pelo WhatsApp: todo aviso leva um link para a tela
// do destinatário, e quem abre o link com a sessão vencida caía no login e, dali,
// na home do módulo — o romaneio que ele foi ver sumia. O ProtectedRoute agora
// manda para `/login?volta=<o caminho>`, e o login devolve a pessoa para lá.
//
// ⚠️ Só caminho INTERNO. Um `?volta=https://outro-site` (ou `//outro-site`, que o
// navegador lê como outro host) transformaria o login num redirecionador aberto:
// o link "rizoma.farm/login?volta=…" levaria a senha digitada para um site falso
// depois. Por isso a regra é por lista branca de forma, não por lista negra.

const LIMITE = 500;

/** O caminho de volta, se for seguro; `null` caso contrário. */
export function destinoDeVolta(valor: string | null | undefined): string | null {
  const v = String(valor ?? "").trim();
  if (!v || v.length > LIMITE) return null;
  // Começa com UMA barra e o segundo caractere não é barra nem contrabarra.
  if (v.charAt(0) !== "/" || v.charAt(1) === "/" || v.charAt(1) === "\\") return null;
  // Sem esquema escondido nem caractere de controle.
  if (/[\u0000-\u001f]/.test(v) || /^\/[a-z]+:/i.test(v)) return null;
  // Voltar para o próprio login seria um laço.
  if (v === "/login" || v.indexOf("/login?") === 0) return null;
  return v;
}

/** `/login?volta=<caminho atual>` — o que o ProtectedRoute usa ao expulsar. */
export function loginComVolta(caminho: string, busca: string): string {
  const destino = destinoDeVolta(`${caminho}${busca || ""}`);
  return destino && destino !== "/" ? `/login?volta=${encodeURIComponent(destino)}` : "/login";
}
